import React from "react";
import LegalShell, { LegalDocument, LegalSection } from "@/components/site/LegalShell";

const EFFECTIVE = "January 2026";

export default function TermsOfService() {
    return (
        <LegalShell>
            <LegalDocument
                eyebrow="Terms"
                title="Terms of Service"
                effective={EFFECTIVE}
            >
                <p className="text-zinc-600">
                    These terms govern your use of YugOS. By accessing or using the product
                    you agree to be bound by them.
                </p>

                <LegalSection title="1. Acceptance of terms">
                    <p>
                        By logging in to YugOS you confirm that you have read and accepted
                        these terms. If you do not agree, you must stop using the product.
                    </p>
                </LegalSection>

                <LegalSection title="2. Acceptable use">
                    <p>You agree not to:</p>
                    <ul className="list-disc pl-5 space-y-1.5">
                        <li>Attempt to access, disrupt, or reverse engineer the service.</li>
                        <li>Use the product for any unlawful purpose.</li>
                        <li>
                            Upload material that infringes intellectual-property rights or
                            violates the privacy of third parties.
                        </li>
                        <li>Circumvent rate limits, authentication, or authorization.</li>
                    </ul>
                </LegalSection>

                <LegalSection title="3. User responsibilities">
                    <p>You are responsible for the accuracy of the data you enter into YugOS and for the actions performed by any user you invite into your workspace.</p>
                </LegalSection>

                <LegalSection title="4. Account security">
                    <p>
                        Keep your login credentials confidential. You are responsible for
                        activity performed under your account. Notify us immediately at{" "}
                        <a
                            href="mailto:security@yugos.app"
                            className="text-zinc-950 underline underline-offset-2 hover:text-blue-600"
                        >
                            security@yugos.app
                        </a>{" "}
                        if you suspect unauthorized access.
                    </p>
                </LegalSection>

                <LegalSection title="5. Intellectual property">
                    <p>
                        The YugOS name, brand, source code, product design and documentation
                        are the intellectual property of Yug Traders LLP. You retain full
                        ownership of the business data you enter; we do not claim any rights
                        over it.
                    </p>
                </LegalSection>

                <LegalSection title="6. AI-generated insights">
                    <p>
                        Yug Brain generates insights on top of your live business data. These
                        outputs are provided <em>as-is</em> and are intended as decision
                        support, not as professional financial, tax, or legal advice. You are
                        responsible for reviewing any AI-generated suggestion before acting
                        on it. YugOS makes no warranty as to the accuracy, completeness or
                        fitness of AI-generated content for any specific purpose.
                    </p>
                </LegalSection>

                <LegalSection title="7. Limitation of liability">
                    <p>
                        To the maximum extent permitted by applicable law, YugOS, Yug Traders
                        LLP and its affiliates will not be liable for any indirect,
                        incidental, consequential or punitive damages, or for any loss of
                        profits or revenue, arising out of or related to your use of the
                        product.
                    </p>
                </LegalSection>

                <LegalSection title="8. Service availability">
                    <p>
                        YugOS is provided on an <em>as available</em> basis. We work hard to
                        keep the product reliable but do not guarantee uninterrupted or
                        error-free operation. Scheduled maintenance, upstream provider
                        incidents, or emergency changes may occasionally cause downtime.
                    </p>
                </LegalSection>

                <LegalSection title="9. Governing law">
                    <p>
                        These terms are governed by the laws of India. Any dispute arising
                        from the use of YugOS shall be subject to the exclusive jurisdiction
                        of the courts of India.
                    </p>
                </LegalSection>

                <LegalSection title="10. Contact">
                    <p>
                        Questions about these terms can be sent to{" "}
                        <a
                            href="mailto:legal@yugos.app"
                            className="text-zinc-950 underline underline-offset-2 hover:text-blue-600"
                        >
                            legal@yugos.app
                        </a>
                        .
                    </p>
                </LegalSection>
            </LegalDocument>
        </LegalShell>
    );
}
